import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PeriodoAmbitoViewModel } from './ambito.types';

@Injectable()
export class PeriodoAmbitoService {
    ambitoPeriodoEndpoint = this.baseUrl + 'api/mantenimiento/periodos/ambito/';
    private _ambitoPeriodo: PeriodoAmbitoViewModel;

    constructor(
        private http: HttpClient,
        @Inject('BASE_URL') private baseUrl: string,
    ) {}

    /**
     * Invokes the service to get the AmbitoPeriodo, applying the filter in the parameter
     * @param payload IdPeriodo number
     * @returns PeriodoAmbitoViewModel
     */
    getAmbitoPeriodo(id: number): Observable<PeriodoAmbitoViewModel> {
        return this.http.get<PeriodoAmbitoViewModel>(this.ambitoPeriodoEndpoint + id);
    }

    saveAmbitoPeriodo(payload: PeriodoAmbitoViewModel): Observable<any> {
        return this.http.put<PeriodoAmbitoViewModel>(this.ambitoPeriodoEndpoint, payload);
    }

    get ambitoPeriodo(): PeriodoAmbitoViewModel {
        return this._ambitoPeriodo;
    }

    set ambitoPeriodo(ambitoPeriodo: PeriodoAmbitoViewModel) {
        this._ambitoPeriodo = ambitoPeriodo;
    }
}
